import CreateCircular from "./routes/CreateCircular";
import UpdateCircular from "./routes/UpdateCircular";
import CircularsWrapper from "./CircularsWrapper";
import CreateCircularV2 from "./routes/CreateCircular/index.v2";

// NOTE: The order these are defined matter!!
export const CircularRoutes = [
  CreateCircular,
  CreateCircularV2,
  UpdateCircular,
  CircularsWrapper, // keep this route at bottom
];
